import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DatosNomina } from 'src/app/domain/model/datosnomina/datos-nomina';

/**
 * Adaptador HTTP: HttpDatosNominaRepository (HU1259115, auditoría de
 * fidelidad fase 25/26).
 *
 * Endpoint: GET /api/servicios/empleados/datos-nomina/{cdpersona}
 * Retorna `null` en 404 (la persona nunca tuvo nómina) — no es un error,
 * el llamador lo trata como "campos vacíos y editables".
 */
@Injectable({ providedIn: 'root' })
export class HttpDatosNominaRepository {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.backend.baseUrl}/servicios/empleados/datos-nomina`;

  async consultar(cdpersona: number): Promise<DatosNomina | null> {
    return firstValueFrom(
      this.http.get<DatosNomina>(`${this.baseUrl}/${cdpersona}`).pipe(
        catchError((error) => {
          if (error?.status === 404) {
            return of(null);
          }
          throw error;
        })
      )
    );
  }
}
